<section class="page-shell">
  <header class="page-header">
    <div>
      <h4>Signatures investisseur</h4>
      <p>Consultez et corrigez les états d’avancement DER, Recueil et QPI.</p>
    </div>
  </header>

  @if (error() && !loadingInvestor()) {
    <dbw-state-card appearance="error" title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <article class="panel dbw-card dbw-card--xl search-panel">
    <h5>Investisseur</h5>
    <div class="search-row">
      <oui-textfield
        label="Identifiant investisseur"
        type="number"
        [value]="investorIdInput()"
        (valueChange)="onInvestorIdChange($event ? $event.toString() : '')">
      </oui-textfield>
      <oui-button (click)="loadInvestor()" [disabled]="loading() || loadingInvestor()">
        Rechercher
      </oui-button>
    </div>
  </article>

  @if (loading()) {
    <dbw-state-card appearance="loading" [compact]="true">
      <p>Chargement du catalogue des états.</p>
    </dbw-state-card>
  }

  @if (loadingInvestor()) {
    <dbw-state-card appearance="loading" [compact]="true">
      <p>Chargement des signatures de l’investisseur.</p>
    </dbw-state-card>
  }

  @if (signature() && !loadingInvestor()) {
    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h5>États de signature — investisseur {{ signature()!.investorId }}</h5>
          <p>Les modifications sont historisées et nécessitent une habilitation dédiée.</p>
        </div>
      </div>

      @if (canUpdateState()) {
        <oui-textfield
          class="reason-field"
          label="Motif de correction"
          [value]="reason()"
          (valueChange)="onReasonChange($event ? $event.toString() : '')">
        </oui-textfield>
      }

      <div class="signature-grid">
        @for (card of cards(); track card.category) {
          <section class="signature-card">
            <h6>{{ card.label }}</h6>
            <dl>
              <dt>État actuel</dt>
              <dd>{{ optionLabel(card) }}</dd>
              <dt>Document GED</dt>
              <dd class="document-id">{{ card.documentId ?? 'Non renseigné' }}</dd>
            </dl>

            @if (canUpdateState() && card.state !== null) {
              <div class="update-row">
                <label [for]="card.category">Nouvel état</label>
                <select #stateSelect [id]="card.category" [value]="card.state">
                  @for (option of card.options; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
                <oui-button
                  (click)="updateState(card, stateSelect.value)"
                  [disabled]="updatingCategory() !== undefined">
                  Mettre à jour
                </oui-button>
              </div>
            }
          </section>
        }
      </div>

      <h5 class="documents-title">Documents GED associés</h5>
      @if (documents().length === 0) {
        <p>Aucun document de signature n’a été retourné par la GED.</p>
      } @else {
        <ul class="documents-list">
          @for (document of documents(); track document.documentId) {
            <li class="document-details">
              <div><strong>{{ document.role }}</strong> — {{ document.designation ?? document.documentId }}</div>
              <dl>
                <dt>DocumentId</dt><dd class="document-id">{{ document.documentId }}</dd>
                <dt>État de signature GED</dt><dd>{{ document.signatureState ?? '—' }}</dd>
                <dt>État de validité</dt><dd>{{ document.validityState ?? '—' }}</dd>
                <dt>Identifiant de signature</dt><dd class="document-id">{{ document.signatureId ?? '—' }}</dd>
                <dt>Dernière mise à jour</dt><dd>{{ document.timestamp ?? document.creationDate ?? '—' }}</dd>
                <dt>Date de signature</dt><dd>{{ document.signatureDate ?? '—' }}</dd>
                <dt>Actif</dt><dd>{{ document.isActive === null || document.isActive === undefined ? '—' : document.isActive ? 'Oui' : 'Non' }}</dd>
              </dl>
              @if (document.error) { <span class="document-error">{{ document.error }}</span> }
              @if (document.sharedUri) {
                <a [href]="document.sharedUri" target="_blank" rel="noopener">Ouvrir</a>
              }
              @if (canCancelGedSignature()) {
                <oui-button
                  class="cancel-button"
                  color="error"
                  (click)="cancelGedSignature(document)"
                  [disabled]="cancellingGedDocumentId() !== undefined">
                  Annuler la signature GED
                </oui-button>
              }
              @if (canConfirmUniversignSignature()) {
                <oui-button
                  class="cancel-button"
                  (click)="findUniversignMatches(document)"
                  [disabled]="loadingMatchesDocumentId() !== undefined">
                  Rechercher dans Universign
                </oui-button>
              }
            </li>
          }
        </ul>
      }

      @if (selectedDocument()) {
        <section class="universign-matches">
          <h6>Correspondances Universign — {{ selectedDocument()!.designation ?? selectedDocument()!.documentId }}</h6>
          @if (loadingMatchesDocumentId()) { <p>Recherche des transactions sur les 180 derniers jours.</p> }
          @if (!loadingMatchesDocumentId() && matches().length === 0) { <p>Aucune correspondance Universign.</p> }
          @for (match of matches(); track match.transactionId) {
            <div class="match-row"><span><strong>{{ match.transactionId }}</strong> — {{ match.status }} — {{ match.fileName }} — créé le {{ match.creationDate ?? '—' }}</span>
              @if (canConfirmUniversignSignature() && match.status.toLowerCase() === 'completed') {
                <oui-button (click)="confirmUniversignMatch(match)" [disabled]="confirmingDocumentId() !== undefined">Confirmer</oui-button>
              }
            </div>
          }
        </section>
      }

    </article>
  }
</section>